import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { write, utils } from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Col, Row, Spin, message } from 'antd';

import InvoiceListComponent from '../../components/invoices/InvoiceListComponent';
import {
  InvoiceApprovalType,
  InvoiceType,
  deleteInvoiceAsync,
  getInvoiceListAsync,
  invoiceStatusKorean,
} from '../../modules/invoices';
import { RootState } from '../../modules';
import InvoiceCreateDrawer from './InvoiceCreateDrawer';
import InvoiceDetailDrawer from './InvoiceDetailDrawer';
import { bulkUpdateInvoiceStatus, getExpenseCommon } from '../../api/constlink';
import SearchInvoiceComponent from '../../components/expenses/SearchInvoiceComponent';
import { s2ab } from '../../util/utils';
import saveAs from 'file-saver';
import {
  VendorType,
  VendorWorkerWageForm,
  vendorWorkerWageFormKorean,
} from '../../modules/vendors';

interface InvoiceListELContainerProps {
  enterpriseId: string;
}

function InvoiceListELContainer({
  match,
  history,
}: RouteComponentProps<InvoiceListELContainerProps>) {
  const { enterpriseId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.invoices.invoices,
  );
  const user = useSelector((state: RootState) => state.auth.auth.data);
  // const [visibleDetailDrawer, setVisibleDetailDrawer] =
  //   useState<boolean>(false);
  // const [detailDrawerConfig, setDetailDrawerConfig] = useState<any>();
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const [detailDrawerConfig, setDetailDrawerConfig] = useState<any>();
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [expenseCommon, setExpenseCommon] = useState<any>();
  const [searchData, setSearchData] = useState<any>({
    member: -1,
    project: -1,
    category: '',
    gongjong: '',
    name: '',
    status: '',
    isCreditTransaction: '',
    startDate: dayjs().startOf('month'),
    endDate: dayjs().endOf('month'),
    isAskedOfMe: false,
    // expenseStatus: ExpenseStatus.SUBMITTED,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getInvoiceListAsync.request({
        enterpriseId,
        filterData: {
          startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
          endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
        },
      }),
    );
  }, [enterpriseId, dispatch]);

  useEffect(() => {
    (async () => {
      const _expenseCommon = await getExpenseCommon(enterpriseId);
      setExpenseCommon({
        ..._expenseCommon,
        // expenseStatus: ExpenseStatus.SUBMITTED,
      });
    })();
  }, [dispatch, enterpriseId]);

  const onDelete = (invoiceId: string) => {
    dispatch(
      deleteInvoiceAsync.request({
        enterpriseId,
        invoiceId,
      }),
    );
  };

  const moveToCreatePage = () => {
    setVisibleCreateDrawer(true);
  };
  const downloadFile = async (data: any) => {
    const _data: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const val: any[] = [];
      val.push(dayjs(data[i].billingDate).format('YYYY-MM-DD'));
      val.push(data[i].vendor.application.general.name);
      val.push(data[i].category);
      val.push(data[i].gongjong ?? '기타');
      val.push(
        data[i].vendor.type === VendorType.COMPANY ? '사업자' : '작업자',
      );
      val.push(
        data[i].vendor.application.general.jobLevel === undefined
          ? ''
          : data[i].vendor.application.general.jobLevel === '1'
          ? '기공'
          : '조공',
      );
      val.push(
        data[i].vendor.application.general.wageForm === undefined
          ? ''
          : vendorWorkerWageFormKorean[
              data[i].vendor.application.general
                .wageForm as VendorWorkerWageForm
            ],
      );
      val.push(invoiceStatusKorean[data[i].status as InvoiceType]);
      val.push(data[i].price - data[i].vat);
      val.push(data[i].vat);
      val.push(data[i].price);

      val.push(
        data[i].vendor.application.general.wageForm === undefined
          ? 0
          : data[i].vendor.application.general.wageForm ===
            VendorWorkerWageForm.FREELANCER
          ? Math.floor((data[i].price * 0.033) / 10) * 10
          : 0,
      );
      val.push(
        data[i].vendor.application.general.wageForm === undefined
          ? data[i].price
          : data[i].vendor.application.general.wageForm ===
            VendorWorkerWageForm.FREELANCER
          ? data[i].price - Math.floor((data[i].price * 0.033) / 10) * 10
          : data[i].price,
      );
      val.push(data[i].vendor.application.accountInfo.bankName);
      val.push(data[i].vendor.application.accountInfo.accountNumber);
      val.push(data[i].vendor.application.accountInfo.accountHolder);

      val.push(data[i].isCreditTransaction === true ? '예' : '아니오');
      val.push(data[i].submittedBy.name);
      val.push(data[i].project ? data[i].project.name : '');

      _data.push(val);
    }
    var wb = utils.book_new();
    const ws = await utils.json_to_sheet(_data);
    [
      '청구일',
      '거래처명',
      '용도',
      '공종',
      '거래처 유형',
      '급여수준',
      '급여방식',
      '상태',
      '공급가액',
      '부가세액',
      '합계금액',
      '원천세',
      '원천세 제외금액',
      '거래처 은행명',
      '거래처 계좌번호',
      '거래처 예금주명',
      '외상거래',
      '제출자',
      '현장명',
    ].forEach((x, idx) => {
      const cellAdd = utils.encode_cell({ c: idx, r: 0 });
      ws[cellAdd].v = x;
    });
    utils.book_append_sheet(
      wb,
      ws,
      `${searchData.startDate.format('YYYY-MM-DD')}~${searchData.endDate.format(
        'YYYY-MM-DD',
      )}`,
    );
    const wbout = write(wb, { bookType: 'xlsx', type: 'binary' });
    saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      `청구서_${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
    );
  };

  const onCloseInvoiceCreateDrawer = () => {
    setVisibleCreateDrawer(false);
  };

  const moveToDetailPage = (invoiceId: string) => {
    setDetailDrawerConfig({
      enterpriseId,
      invoiceId,
      isEnterpriseLevel: true,
    });
    setVisibleDetailDrawer(true);
  };

  const onCloseInvoiceDetailDrawer = () => {
    setVisibleDetailDrawer(false);
  };

  const _searchInvoices = (data: any) => {
    const filterData: any = {
      ...data,
      startDate: dayjs(data.startDate).format('YYYY-MM-DD'),
      endDate: dayjs(data.endDate).format('YYYY-MM-DD'),
    };

    // if (data.memberId !== -1) filterData.memberId = data.member;
    if (data.member !== -1) filterData.memberId = data.member;
    else filterData.memberId = undefined;
    if (data.project !== -1) filterData.projectId = data.project;
    else filterData.projectId = undefined;
    if (data.name === '') filterData.name = undefined;
    if (data.category === '') filterData.category = undefined;
    if (data.gongjong === '') filterData.gongjong = undefined;
    if (data.status === '') filterData.status = undefined;
    if (data.isCreditTransaction === '')
      filterData.isCreditTransaction = undefined;

    dispatch(
      getInvoiceListAsync.request({
        enterpriseId,
        filterData: {
          ...filterData,
        },
      }),
    );
    setSearchData({
      ...data,
      startDate: dayjs(data.startDate),
      endDate: dayjs(data.endDate),
    });
  };

  const _initSearchForm = () => {
    setSearchData({
      member: -1,
      project: -1,
      category: '',
      gongjong: '',
      name: '',
      status: '',
      isCreditTransaction: '',
      startDate: dayjs().startOf('month'),
      endDate: dayjs().endOf('month'),
      isAskedOfMe: false,
    });
  };

  const _bulkUpdateInvoiceStatus = async (
    idList: number[],
    approvalType: InvoiceApprovalType,
    declineReason?: string,
  ) => {
    const params: any = {
      enterpriseId,
      idList,
      approvalType,
    };
    if (declineReason) {
      params.declineReason = declineReason;
    }

    const result = await bulkUpdateInvoiceStatus(params);
    _searchInvoices(searchData);
    if (result) {
      message.success('청구서 상태를 변경하였습니다.');
    } else {
      message.error('청구서 상태가 변경되지 않았습니다.');
    }
  };

  const moveToProjectDetailPage = (projectId: number) => {
    history.push(
      `/enterprises/${enterpriseId}/projects/${projectId}/dashboard`,
    );
  };

  return (
    <>
      {error && <Alert message={`${error}`} type="error" showIcon closable />}

      <Row justify="space-between">
        <Col span={4} style={{ marginTop: '10px' }}>
          {expenseCommon && searchData && (
            <SearchInvoiceComponent
              expenseCommon={expenseCommon}
              searchData={searchData}
              enterpriseId={enterpriseId}
              searchInvoices={_searchInvoices}
              initSearchForm={_initSearchForm}
            />
          )}
        </Col>
        {data && user && (
          <Col span={20}>
            <InvoiceListComponent
              data={data}
              user={user}
              isProjectLevel={false}
              moveToDetailPage={moveToDetailPage}
              moveToCreatePage={moveToCreatePage}
              onDelete={onDelete}
              downloadFile={downloadFile}
              bulkUpdateInvoiceStatus={_bulkUpdateInvoiceStatus}
              moveToProjectDetailPage={moveToProjectDetailPage}
            />
          </Col>
        )}
        {loading && (
          <Col>
            <Spin />
          </Col>
        )}
      </Row>
      <InvoiceCreateDrawer
        enterpriseId={enterpriseId}
        visible={visibleCreateDrawer}
        onClose={onCloseInvoiceCreateDrawer}
      />
      {detailDrawerConfig && (
        <InvoiceDetailDrawer
          config={detailDrawerConfig}
          visible={visibleDetailDrawer}
          onClose={onCloseInvoiceDetailDrawer}
        />
      )}
    </>
  );
}

export default withRouter(InvoiceListELContainer);
